import { ProductNodeBuilderProps } from 'components/common-form/builder/form/node/ProductNodeBuilder.model';
import { useData } from 'components/common-form/hooks/useData';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { LabelWithTooltip } from 'components/shared/LabelWithTooltip/LabelWithTooltip';
import type { LabelFieldData, LabelFieldMetadata } from 'models/forms/fields/LabelFieldMetadata';
import { FC } from 'react';

export const ClientLabelField: FC<ProductNodeBuilderProps> = ({ node: { id } }) => {
  const [value] = useData<Extract<LabelFieldData, { id?: string; label?: string }>>(id)!;
  const translationKey = useFieldTranslationKey(id);
  const clientNameWithBdrId = `${value?.label} (${value?.id})`;
  const metadata = useFieldMetadata<LabelFieldMetadata>(id);

  return (
    <BlockOrientationFormGroup
      inputId={id}
      label={`form.${translationKey}` as any}
      minWidth={metadata?.minWidth}
      maxWidth={metadata?.maxWidth}
    >
      <LabelWithTooltip
        label={clientNameWithBdrId}
        tooltip={clientNameWithBdrId}
        hasTooltip={metadata?.hasTooltip}
        className="text-start text-nowrap overflow-hidden"
      />
    </BlockOrientationFormGroup>
  );
};

ClientLabelField.displayName = 'ClientLabelField';
